import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import IVButton from '@invideoio/uniformd/components/Button';
import ivclass from '../../../../Modules/IVClass';
import HeaderConfig from '../../../../constants/header';
import { PlatformType } from '../../../../constants/common';
import MenuItem from './MenuItem';
import Title from './Title';
import useSharedState from '../../../../hooks/useSharedState';
import { translate } from '../../../../utils/common';
import { MenuType } from '../../../Header/constant';
const subMenuItem = (link, onNext, state, index, authFunctions) => {
    const { color, external, icon, name, type, url, platform, linkKey, promo, showAuth, } = link;
    return (platform !== PlatformType.Desktop && (_jsx("div", { className: ivclass('iv-pb-25'), children: _jsx(MenuItem, { objectKey: linkKey, className: ivclass('iv-inline-block', 'iv-pr-8', type === MenuType.NESTED && 'iv-mt-20', color || 'iv-text-grey-50', 'iv-m-body-2xl', type === MenuType.NESTED
                ? 'iv-text-heading-4xs'
                : 'iv-text-body-2xl', 'iv-font-medium'), color: color, external: external, icon: icon, name: translate(`name`, { siteId: state.siteConfig?.site?.name }, { default: name }), type: type, url: url, onNext: onNext, platform: platform, linkKey: linkKey, promo: promo, showAuth: showAuth, authFunctions: authFunctions }) }, index)));
};
const SubMenu = (props) => {
    const { subMenu, onBack, onNext, authFunctions } = props;
    const { name, links, color } = subMenu;
    const { state } = useSharedState();
    return (_jsxs(React.Fragment, { children: [_jsx("div", { className: ivclass('iv-py-25'), children: _jsx(IVButton, { onClick: () => onBack(), className: ivclass('iv-flex', 'iv-items-center'), children: _jsx(Title, { color: color, title: translate(`name`, { siteId: state.siteConfig?.site?.name }, { default: name }), icon: HeaderConfig.BACK_ICON_MOBILE }) }) }), links &&
                Object.keys(links).map((link, idx) => {
                    const item = links[link];
                    return (_jsxs(_Fragment, { children: [subMenuItem(item, onNext, state, idx, authFunctions), item.links &&
                                Object.keys(item.links).map((link, idx) => {
                                    const subItem = item.links[link];
                                    return subMenuItem(subItem, onNext, state, idx, authFunctions);
                                })] }));
                })] }));
};
export default SubMenu;
